"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPStatus = void 0;
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/HTTP/Status HTTP response status codes}
 */
var HTTPStatus;
(function (HTTPStatus) {
    HTTPStatus[HTTPStatus["Continue"] = 100] = "Continue";
    HTTPStatus[HTTPStatus["SwitchingProtocol"] = 101] = "SwitchingProtocol";
    HTTPStatus[HTTPStatus["EarlyHints"] = 103] = "EarlyHints";
    HTTPStatus[HTTPStatus["OK"] = 200] = "OK";
    HTTPStatus[HTTPStatus["Created"] = 201] = "Created";
    HTTPStatus[HTTPStatus["Accepted"] = 202] = "Accepted";
    HTTPStatus[HTTPStatus["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    HTTPStatus[HTTPStatus["NoContent"] = 204] = "NoContent";
    HTTPStatus[HTTPStatus["ResetContent"] = 205] = "ResetContent";
    HTTPStatus[HTTPStatus["PartialContent"] = 206] = "PartialContent";
    HTTPStatus[HTTPStatus["MultipleChoices"] = 300] = "MultipleChoices";
    HTTPStatus[HTTPStatus["MovedPermanently"] = 301] = "MovedPermanently";
    HTTPStatus[HTTPStatus["Found"] = 302] = "Found";
    HTTPStatus[HTTPStatus["SeeOther"] = 303] = "SeeOther";
    HTTPStatus[HTTPStatus["NotModified"] = 304] = "NotModified";
    HTTPStatus[HTTPStatus["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    HTTPStatus[HTTPStatus["PermanentRedirect"] = 308] = "PermanentRedirect";
    HTTPStatus[HTTPStatus["BadRequest"] = 400] = "BadRequest";
    HTTPStatus[HTTPStatus["Unauthorized"] = 401] = "Unauthorized";
    HTTPStatus[HTTPStatus["PaymentRequired"] = 402] = "PaymentRequired";
    HTTPStatus[HTTPStatus["Forbidden"] = 403] = "Forbidden";
    HTTPStatus[HTTPStatus["NotFound"] = 404] = "NotFound";
    HTTPStatus[HTTPStatus["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HTTPStatus[HTTPStatus["NotAcceptable"] = 406] = "NotAcceptable";
    HTTPStatus[HTTPStatus["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    HTTPStatus[HTTPStatus["RequestTimeout"] = 408] = "RequestTimeout";
    HTTPStatus[HTTPStatus["Conflict"] = 409] = "Conflict";
    HTTPStatus[HTTPStatus["Gone"] = 410] = "Gone";
    HTTPStatus[HTTPStatus["LengthRequired"] = 411] = "LengthRequired";
    HTTPStatus[HTTPStatus["PreconditionFailed"] = 412] = "PreconditionFailed";
    HTTPStatus[HTTPStatus["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    HTTPStatus[HTTPStatus["URITooLong"] = 414] = "URITooLong";
    HTTPStatus[HTTPStatus["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    HTTPStatus[HTTPStatus["RangeNotSatisfiable"] = 416] = "RangeNotSatisfiable";
    HTTPStatus[HTTPStatus["ExpectationFailed"] = 417] = "ExpectationFailed";
    HTTPStatus[HTTPStatus["IAmATeapot"] = 418] = "IAmATeapot";
    HTTPStatus[HTTPStatus["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    HTTPStatus[HTTPStatus["TooEarly"] = 425] = "TooEarly";
    HTTPStatus[HTTPStatus["UpgradeRequired"] = 426] = "UpgradeRequired";
    HTTPStatus[HTTPStatus["PreconditionRequired"] = 428] = "PreconditionRequired";
    HTTPStatus[HTTPStatus["TooManyRequests"] = 429] = "TooManyRequests";
    HTTPStatus[HTTPStatus["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    HTTPStatus[HTTPStatus["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    HTTPStatus[HTTPStatus["InternalServerError"] = 500] = "InternalServerError";
    HTTPStatus[HTTPStatus["NotImplemented"] = 501] = "NotImplemented";
    HTTPStatus[HTTPStatus["BadGateway"] = 502] = "BadGateway";
    HTTPStatus[HTTPStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HTTPStatus[HTTPStatus["GatewayTimeout"] = 504] = "GatewayTimeout";
    HTTPStatus[HTTPStatus["HTTPVersionNotSupported"] = 505] = "HTTPVersionNotSupported";
    HTTPStatus[HTTPStatus["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    HTTPStatus[HTTPStatus["InsufficientStorage"] = 507] = "InsufficientStorage";
    HTTPStatus[HTTPStatus["LoopDetected"] = 508] = "LoopDetected";
    HTTPStatus[HTTPStatus["NotExtended"] = 510] = "NotExtended";
    HTTPStatus[HTTPStatus["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
})(HTTPStatus || (exports.HTTPStatus = HTTPStatus = {}));
